import { render, staticRenderFns } from "./MyFilterIcon.vue?vue&type=template&id=5d3705af"
import script from "./MyFilterIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyFilterIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports